import type { Theme } from "@mui/material";

export const CHAT_CONTENT_WIDTH = "900px";

export const CHAT_TEXT = {
  "& .MuiTypography-body1": { fontSize: (theme: Theme) => theme.typography.pxToRem(14), lineHeight: 1.5 },
} as const;
